WL.registerComponent('conveyor-movement', {
    speed: { type: WL.Type.Float, default: 1.0 },
    endOfBelt: { type: WL.Type.Float, default: 1.4 },

}, {
    init: function () {
        this.isMoving = false;
        /* Set by 'gift-spawner'.spawn() */
        this.pool = null;
        this.isGrabbed = false;
        this.despawnTimeoutSeconds = 2;
        this.wrapper = this.object.getComponent('wrapper');
        window.SW.gameState.stateSubject.subscribe(
            this.handleStateChange.bind(this));
        window.SW.gameState.cryingKidsSubject.subscribe((v) => {
            if (v >= 5) {
                this.isMoving = false;
            }
        });
    },
    handleStateChange(state) {
        if (state != State.gameplay) {
            this.reset();
            //     this.active = false;
        }
    },
    go() {
        this.active = true;
        this.isMoving = true;
        this.physx.kinematic = true;
        this.object.getTranslationWorld(this.startPos);
    },

    reset() {
        this.isGrabbed = false;
        this.isMoving = false;
        if (this.physx) {
            this.physx.kinematic = true;
        }
        this.isDespawning = false;
        //  this.active = false;
        /* Place somewhere "away", use objectId to avoid emitting collision event */
        this.object.setTranslationWorld([-100 - this.object.objectId * 2, -100, -100]);
    },

    start: function () {
        this.physx = this.object.getComponent('physx');

        this.startPos = new Float32Array(3);
        this.physx.onCollision(this.onCollision.bind(this));
        const grabbable = this.object.getComponent('grabbable');
        grabbable.registerGrabEventListener(this, this.onGrab.bind(this));
        grabbable.registerUngrabEventListener(this, this.onUngrab.bind(this));

        this.reset();
    },
    onGrab() {
        window.SW.instructions.play('grab');
        this.isGrabbed = true;
        this.isMoving = false;
        this.cancelDespawnTimout();
    },

    cancelDespawnTimout() {
        if (this.despawnTimeout) {
            clearTimeout(this.despawnTimeout);
            this.despawnTimeout = null;
        }
    },

    onUngrab() {
        this.isGrabbed = false;
        if (!this.despawnTimeout) {
            this.despawnTimeout = setTimeout(this.despawn.bind(this), this.despawnTimeoutSeconds * 1000);
        }
    },
    update: function (dt) {
        if (this.isMoving) {
            this.startPos[0] += this.speed * dt;
            this.object.setTranslationWorld(this.startPos);
        }
        if (this.startPos[0] > this.endOfBelt && this.isMoving) {
            this.isMoving = false;
            this.physx.kinematic = false;
            this.physx.addForce([120, 0, 0], undefined, undefined, undefined, [0, .15, 0]);
        }
    },

    onCollision(event, other) {
        if (!this.active || !this.pool) return;
        if (this.isGrabbed) return;

        /* Nothing to do on "uncollide" events */
        if (event == WL.CollisionEventType.TouchLost) return;

        if (other.object.name == 'FloorCollision') {
            this.despawn();
        }

        /* Start moving again, when placed back on the conveyor */
        // if (!this.isMoving && other.object.name == 'Spawner') {
        //     this.isMoving = true;
        //     this.cancelDespawnTimout();
        // }
    },
    sacked() {
        this.cancelDespawnTimout();
        poof(this.object.getTranslationWorld([]));
        this.active = false;
        this.wrapper.reset();
        this.pool.removeFromPool(this.object);
    },
    despawn() {
        this.cancelDespawnTimout();
        poof(this.object.getTranslationWorld([]));
        this.pool.despawn(this.object);
        this.active = false;
        this.wrapper.reset();
        window.SW.gameState.addCryingKid();
    }
});
